import { toNumber } from "lodash";

const OSS_PATH = process.env.VUE_APP_OSSPath;
const getOssPath = (path) => {
  return `${OSS_PATH}${path}`;
};

//统一处理price
export const filterPrice = (p, defaultStr = "") => {
  if (typeof p === "number") {
    // 如果 p 是数字，直接使用
    return `${p.toFixed(2)}`;
  } else if (typeof p === "string") {
    // 如果 p 是字符串，去除逗号并转换为数字，然后保留两位小数
    const numericValue = toNumber(p.replace(/,/g, ""));
    return `${numericValue.toFixed(2)}`;
  } else {
    // 其他类型，返回空字符串或其他默认值
    return defaultStr;
  }
};

// 统一处理price
export const floatPrice = (p) => {
  if (typeof p === "number") {
    // 如果 p 是数字，直接使用
    return toNumber(p.toFixed(2));
  } else if (typeof p === "string") {
    // 如果 p 是字符串，去除逗号并转换为数字，然后保留两位小数
    const numericValue = toNumber(p.replace(/,/g, ""));
    return toNumber(numericValue.toFixed(2));
  } else {
    // 其他类型，返回空字符串或其他默认值
    return;
  }
};

export default {
  getOssPath,
  filterPrice,
  floatPrice,
};
